import { LuckyDrawList } from "../customer/luckyDrawList"

/**
 * LuckyDrawDashboard component renders the LuckyDrawList for the dashboard view.
 */
export const LuckyDrawDashboard = () => {
    return <LuckyDrawList />
}